import React, { useState } from "react"
import { Box, Card, Typography, CircularProgress } from "@material-ui/core"
import CheckIcon from "@material-ui/icons/Check"
import useStyles from "./styles"
import PropTypes from "prop-types"
import { useDispatch } from "react-redux"
import { openSnackBar } from "../../../../actions/snack-bar"
import { updateSoloStatus } from "../../../../actions/solos"
import GreenButton from "../../Common/GreenButton"
import {
  toggleDigitalSignatureDialog,
  toggleBillingPaymentDialog,
  toggleSendBillingDialog,
} from "../../../../actions/billingDialogs"
import moment from "moment"
import classNames from "classnames"
import LoadingButton from "../../../LoadingButton/index"
import formatNumberWithCommas from "../../../../utils/formatNumberWithCommas"
import SendLog from "../SendLog/index"
import capitalizeFirstLetter from "../../../../utils/capitalizeFirstLetter"

const ClientSoloRightActions = ({
  type = "",
  soloData = {},
  setSoloData = () => {},
  amounts = {},
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const id = soloData && soloData[`${type.toLowerCase()}_id`]
  const soloAccepted = soloData && Boolean(soloData.client_accepted)
  const clientPaid =
    (soloData && Boolean(soloData.full_amount)) ||
    Boolean(soloData.first_payment_type) ||
    Boolean(soloData.first_payment_type)

  const companyLogo =
    soloData &&
    soloData.company_logo_image &&
    JSON.parse(soloData.company_logo_image).url

  const [approveWorking, toggleApproveWorking] = useState(false)
  const [reportWorking, toggleReportWorking] = useState(false)

  const changePaymentMethodIfCheck =
    soloData &&
    ((soloData.first_payment_type === "check" ||
      soloData.first_payment_type === "ach") &&
      !soloData.full_paid)

  // *** APPROVE CLIENT  ***
  // client accepts - open digital signature, then make update solo status call
  const handleClientApprove = dialogData => {
    toggleApproveWorking(true)
    let request = {
      client_accepted: +dialogData.termsAccepted,
      client_signature: dialogData.fullName,
      client_terms_accepted: +dialogData.termsAccepted,
    }
    dispatch(updateSoloStatus(type, id, request))
      .then(() => {
        setSoloData({
          ...soloData,
          client_accepted: +dialogData.termsAccepted,
          client_signature: dialogData.fullName,
          client_terms_accepted: +dialogData.termsAccepted,
          [`${type}_accepted_date`]: moment().format(),
        })
        dispatch(
          openSnackBar({
            message: `You have successfully approved this ${type}`,
          })
        )
        toggleApproveWorking(false)
      })
      .catch(err => {
        console.log(err)
        toggleApproveWorking(false)
        dispatch(openSnackBar({ messgae: `Error approving this ${type}` }))
      })
  }

  const openSignatureDialog = () => {
    let dialogData = {
      headerLogo: companyLogo,
      acceptFunc: handleClientApprove,
    }
    dispatch(toggleDigitalSignatureDialog(true, dialogData))
  }
  // *** APPROVE CLIENT END ***

  const openPaymentDialog = () => {
    let data = {
      amountDue: amounts.remaining,
      totalAmount: amounts.remaining || soloData.full_amount,
      headerLogo: companyLogo,
      generalData: soloData,
      setGeneralData: setSoloData,
      final: true,
      type: "invoice",
    }
    dispatch(toggleBillingPaymentDialog(true, data))
  }
  // *** REPORT ISSUE  ***

  const reportSoloIssue = dialogVals => {
    toggleReportWorking(true)
    let request = {
      client_report_subject: dialogVals.subject,
      client_report_message: dialogVals.message,
      client_report_sent_to: dialogVals.recipients.join(", "),
    }
    dispatch(updateSoloStatus(type, id, request))
      .then(res => {
        dispatch(
          openSnackBar({
            message: `Report successfully sent to ${soloData.company_name ||
              "Crew Mama"} staff`,
          })
        )
        toggleReportWorking(false)
      })
      .catch(err => {
        console.log(err)
        toggleReportWorking(false)
      })
  }

  const handleOpenReportDialog = () => {
    let subjectName = `${soloData.client_name} - ${
      soloData.client_company_name
    }`
    let defaultEmail = soloData.creator_email
      ? soloData.creator_email.split(",").map(x => x.trim())
      : null
    let dialogData = {
      type: "Issue",
      shootName: subjectName,
      defaultEmail: defaultEmail,
      sendFunc: reportSoloIssue,
    }
    dispatch(toggleSendBillingDialog(true, dialogData))
  }

  // *** REPORT ISSUE END ***

  return (
    <Box>
      <SendLog data={soloData} />
      {!soloAccepted ? (
        <Box
          mt={4}
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
        >
          <Typography variant="h3">Digital Signage & Agreement</Typography>
          <Typography
            align="left"
            variant="subtitle1"
            style={{
              marginBottom: 10,
              marginTop: 10,
            }}
          >
            Please sign off on this {type}
          </Typography>
          <Box alignSelf="center" width="80%" mt={4}>
            <GreenButton
              variant="contained"
              fullWidth
              onClick={openSignatureDialog}
              disabled={approveWorking}
            >
              {approveWorking ? (
                <CircularProgress size={24} style={{ color: "#fff" }} />
              ) : (
                `Approve This ${capitalizeFirstLetter(type)}`
              )}
            </GreenButton>
          </Box>
        </Box>
      ) : (
        <Box mb={1}>
          {/* Digital Signature Card */}
          <Card classes={{ root: classes.card }}>
            <Box className={classes.rowWrapper}>
              <Typography variant="h3">Digital Signature</Typography>
              <Box
                className={classNames(classes.statusDot, {
                  [classes.acceptedDot]: soloAccepted,
                })}
              >
                <CheckIcon className={classes.checkIcon} />
              </Box>
            </Box>
            <Typography
              align="left"
              variant="subtitle1"
              style={{
                marginBottom: 10,
                marginTop: 10,
              }}
            >
              Signed on{" "}
              {moment(soloData.client_accepted_date).format(
                "M/D/YY[ @ ]h:mm A"
              )}{" "}
              by {soloData.client_signature}
            </Typography>
          </Card>
          {/* ONLY FOR SOLO INVOICE - Card for payment */}
          {type.toLowerCase() === "invoice" && (
            <Card
              classes={{ root: classes.card }}
              style={{ marginTop: "20px" }}
            >
              <Box className={classes.rowWrapper}>
                <Typography variant="h3">Payment Sent</Typography>
                <Box
                  className={classNames(classes.statusDot, {
                    [classes.acceptedDot]: clientPaid,
                  })}
                >
                  {clientPaid && <CheckIcon className={classes.checkIcon} />}
                </Box>
              </Box>
              <Box mt={2} mb={2}>
                <Box className={classes.rowWrapper}>
                  <Typography className={classes.greenFont}>
                    Amount Due:
                  </Typography>
                  <Typography className={classes.greenFont}>
                    $ {formatNumberWithCommas(amounts.remaining)}
                  </Typography>
                </Box>
                {!Boolean(soloData.full_paid) && (
                  <Box display="flex" justifyContent="center" mt={4}>
                    <GreenButton variant="outlined" onClick={openPaymentDialog}>
                      {changePaymentMethodIfCheck
                        ? "Change Payment Method"
                        : "Submit Payment"}
                    </GreenButton>
                  </Box>
                )}
              </Box>
            </Card>
          )}
        </Box>
      )}
      <Box margin="auto" width="80%" mt={2}>
        <LoadingButton
          fullWidth
          variant="outlined"
          className={classes.redButton}
          onClick={handleOpenReportDialog}
          disabled={reportWorking}
        >
          {reportWorking ? (
            <CircularProgress
              size={20}
              color="inherit"
              style={{ margin: "4px 0" }}
            />
          ) : (
            "Report an Issue"
          )}
        </LoadingButton>
      </Box>
    </Box>
  )
}

ClientSoloRightActions.propTypes = {
  type: PropTypes.string,
  soloData: PropTypes.object,
  setSoloData: PropTypes.func,
  amounts: PropTypes.object,
}

export default ClientSoloRightActions
